import { Component, OnInit } from '@angular/core';
import { ReportsColConfigService } from './reports-col-config.service';
import { Router } from '@angular/router';
import { AppConfigService } from '../../app.config';
import { DisplayModes } from '../../models/enums';
import { Permission } from '../../models/permission.model';
import { AccountService } from '../../services/account.service';
import { AlertService } from '../../services/alert.service';
import { AppTranslationService } from '../../services/app-translation.service';

@Component({
  selector: 'crm-reports-col-config',
  templateUrl: './reports-col-config.component.html',
  styleUrls: ['./reports-col-config.component.css']
})
export class ReportsColConfigComponent implements OnInit {

  data: any[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  searchText: string;
  pageSize: number;
  public logo = require("../../../app/assets/images/demo/Icon_Items Format.png");

  selectedName;
  addNew: boolean = false;

  constructor(private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly translateService: AppTranslationService,
    private readonly appConfig: AppConfigService,
    private readonly reportsColConfigService: ReportsColConfigService,
    private accountService: AccountService) { }

  ngOnInit() {
    this.pageSize = this.appConfig.settings.pageSize;
    this.getConfigurationNames();
  }

  getConfigurationNames() {
    this.displayMode = DisplayModes.Loading;
    this.reportsColConfigService.getAllReportsName().subscribe(responce => {
      this.data = responce as any[];
      this.displayMode = DisplayModes.Success;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get getConfigurationNames');
        console.log(err);
      })

  }

  edit(name) {
    this.selectedName = name;
    this.addNew = true;
  }



  get canManageReportsColumnsConfigurationPermission() {
    return this.accountService.userHasPermission(Permission.manageReportsColumnsConfigurationPermission);
  }

  closeAdding(event) {
    this.selectedName = undefined;
    this.addNew = false;

  }


}
